import * as React from "react"
import { batch } from "@preact/signals-react"
import { DrawerSeeker } from "@ui-seeker/core"

import CatalogueDetailsFormDrawerContent from "./Content"
import { useCatalogueDetailsForm } from "../@hooks"
import { brandForm, catalogueDetailsFormIsOpen, catalogueDetailsFormTitle, catalogueDetailsFormRowData, catalogueDetailsFormRowDataMultiple, skuForm } from "../@signals"


export default function CatalogueDetailsFormDrawer() {
	const { handleUpdate } = useCatalogueDetailsForm()

    return <DrawerSeeker
		isOpen={catalogueDetailsFormIsOpen.value}
		controller={() => batch(() => {
			catalogueDetailsFormTitle.value = null
			catalogueDetailsFormRowData.value = {}
			catalogueDetailsFormRowDataMultiple.value = []
		})}
		title={`EDIT ${catalogueDetailsFormTitle.value}`}
		width="40%"
		successProps={{
			disabled: !brandForm.value && !!skuForm.value,
			onClick: handleUpdate
		}}
	>
    	<CatalogueDetailsFormDrawerContent />
    </DrawerSeeker>
}